import {
  Box, Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  makeStyles,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography
} from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";
import CancelIcon from "@material-ui/icons/Cancel";
import DateRangeIcon from "@material-ui/icons/DateRange";
import { withStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import { useFormik } from "formik";
import { STATUS_PROCESS } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import { getErrorMessage } from "libs/utils/form";
import HttpClient from "libs/utils/HttpClient";
import { isError } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  paper: {
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
    // marginBottom: 60
  },

  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
    textAlign: "center",
  },
  formGroupCenter: {
    alignItems: "center",
  },
  warpRight: {
    textAlign: "right",
    marginTop: 15,
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function ViewReasonDetail() {
  const classes = useStyles();
  let { draftId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoadind] = useState(false);
  const [DialogHistory, setDialogHistory] = useState(false);
  const [DataHistoryContent, setDataHistoryContent] = useState("");
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const { profile } = useSelector((state) => state.user);
  const [reasonList_data, setReasonList_data] = useState([]);
  const [reasonListDirector_data, setReasonListDirector_data] = useState([]);
  const [smartDetail, setSmartDetail] = useState([]);
  const headCellsComments = [
    {
      id: "smartDate",
      numeric: false,
      disablePadding: false,
      label: "Date / Time",
    },
    {
      id: "smartNo",
      numeric: false,
      disablePadding: false,
      label: "Comment",
    },
  ];

  const headCellsReason = [
    {
      id: "smartDate",
      numeric: false,
      disablePadding: false,
      label: "Organization",
    },
    {
      id: "smartNo",
      numeric: false,
      disablePadding: false,
      label: "STATUS",
    },
    {
      id: "smartNo",
      numeric: false,
      disablePadding: false,
      label: "REASON",
    },
  ];

  const getListReason = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/reason/list?draftId=${draftId}&isBOI=false`
      );

      if (response.status) {
        setReasonList_data(response.results);
        console.log(response);
        return response;
      } else {
        setReasonList_data([]);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const getListReasonDirector = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/reason/list?draftId=${draftId}&isBOI=true`
      );

      if (response.status) {
        setReasonListDirector_data(response.results);
        return response;
      } else {
        setReasonListDirector_data([]);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const getSmartDetail = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/list?draftId=${draftId}`
      );

      if (response.status) {
        response?.results.map((x) => {
          setSmartDetail(x);
        });
        return response;
      } else {
        setSmartDetail([]);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  useEffect(async () => {
    await getListReason();
    await getListReasonDirector();
    await getSmartDetail();
  }, []);
  const validationSchema = yup.object({
    commentToPersonal: yup.string().required("Comment Personal is required"),
    commentToDirector: yup.string().required("Comment Director is required"),
  });

  let formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      commentToPersonal: reasonListDirector_data?.[0]?.commentToPersonal
        ? reasonListDirector_data?.[0]?.commentToPersonal
        : "",
      commentToDirector: reasonListDirector_data?.[0]?.commentToDirector
        ? reasonListDirector_data?.[0]?.commentToDirector
        : "",
      radioCheck: reasonListDirector_data?.[0]?.isPass
        ? reasonListDirector_data?.[0]?.isPass
        : false,
    },
    onSubmit: async (values) => {
      const data = {
        configReasonID: null,
        draftId: draftId,
        isPass: values.radioCheck,
        commentToDirector: values.commentToDirector,
        commentToPersonal: values.commentToPersonal,
      };
      try {
        const response = await HttpClient.post(
          "/api/visaformadmin/reason/boistaff",
          data
        );

        if (response.status) {
          alert("สำเร็จ");
          formik.setFieldValue("commentToPersonal", "");
          formik.setFieldValue("commentToDirector", "");
          formik.setFieldValue("radioCheck", false);
          getListReasonDirector();
          return response;
        } else {
          alert("ไม่สำเร็จ");
        }
        return Promise.reject(response);
      } catch (error) {
        const newError = error;
        throw newError;
      }
    },
  });

  return (
    <>
      {/* For Boi Staff */}
      <Paper className={classes.paper} id="admin-view">
        <>
          <ContentTitle title="View Reason" />
          <TableContainer>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  {headCellsReason.map((headCell) => (
                    <TableCell
                      className={classes.tableHead}
                      key={headCell.id}
                      align={headCell.numeric ? "right" : "left"}
                      padding={headCell.disablePadding ? "none" : "normal"}
                    >
                      <TableSortLabel
                        // disabled={headCell?.disabled || true}
                        disabled={headCell?.disabled}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {reasonList_data.map((x) => (
                  <StyledTableRow key="">
                    <StyledTableCell style={{ width: 300 }}>
                      {x?.departmentName}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: 150 }}>
                      {x?.isPass ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <CheckCircle
                            style={{ color: "#2DCE98", marginRight: 10 }}
                          />
                          ผ่าน
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <CancelIcon
                            style={{ color: "#FEB969", marginRight: 10 }}
                          />
                          ไม่ผ่าน
                        </div>
                      )}
                    </StyledTableCell>
                    <StyledTableCell> {x?.commentToDirector}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      </Paper>
      <Paper
        className={classes.paper}
        style={{ marginTop: 15 }}
        id="admin-view"
      >
        <>
          <ContentTitle title="Comments from Director" />
          <div
            className={classes.warpRight}
            style={{
              textDecoration: "underline",
              color: "#00D0FF",
              marginBottom: 5,
              cursor: "pointer",
            }}
          >
            <Typography
              onClick={() => {
                setDialogHistory(true);
                setDataHistoryContent(1);
              }}
            >
              ดูทั้งหมด
            </Typography>
          </div>
          <TableContainer>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  {headCellsComments.map((headCell) => (
                    <TableCell
                      className={classes.tableHead}
                      key={headCell.id}
                      align={headCell.numeric ? "right" : "left"}
                      padding={headCell.disablePadding ? "none" : "normal"}
                    >
                      <TableSortLabel
                        // disabled={headCell?.disabled || true}
                        disabled={headCell?.disabled}
                      >
                        {headCell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {reasonListDirector_data.map(
                  (x, index) =>
                    index < 5 && (
                      <StyledTableRow key="">
                        <StyledTableCell style={{ width: 300 }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <DateRangeIcon
                              style={{ color: "#1094D8", marginRight: 10 }}
                            />
                            {moment(x?.reasonDate).format(
                              "DD/MM/YYYY hh:mm:ss"
                            )}
                          </div>
                        </StyledTableCell>
                        <StyledTableCell>
                          {x?.massDirectorToStaff}
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      </Paper>
      {(smartDetail?.statusProcessId ===
        STATUS_PROCESS.FinalReviewingDirector ||
        smartDetail?.statusProcessId === STATUS_PROCESS.FinalReviewing) && (
        <>
          <Paper
            className={classes.paper}
            style={{ marginTop: 15 }}
            id="admin-view"
          >
            <>
              <ContentTitle title="Summary of Reasons" />
              <div className={classes.warpRight}>
                {/* <Typography
              onClick={() => {
                setDialogHistory(true);
                setDataHistoryContent(2);
              }}
            >
              ประวัติการแก้ไข
            </Typography> */}
                <Typography style={{ color: "#1094D8" }}>
                  {reasonListDirector_data?.[0]?.smartserviceName
                    ? reasonListDirector_data?.[0]?.smartserviceName
                    : ""}
                </Typography>

                <Typography>
                  DOC No.{" "}
                  <font color="#2DCE98">
                    {reasonListDirector_data?.[0]?.smartNo
                      ? reasonListDirector_data?.[0]?.smartNo
                      : ""}
                  </font>
                </Typography>
              </div>
              <form onSubmit={formik.handleSubmit}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    className={classes.warpFormControl}
                  >
                    <InputLabel>ความเห็นเสนอผู้อำนวยการ</InputLabel>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      style={{ marginTop: 10 }}
                    >
                      <TextField
                        variant="outlined"
                        name="commentToDirector"
                        value={formik.values.commentToDirector}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("commentToDirector", formik)}
                        helperText={getErrorMessage(
                          "commentToDirector",
                          formik
                        )}
                        multiline
                        rows={5}
                      />
                    </FormControl>
                  </Grid>

                  <FormControl className={classes.formGroupCenter} fullWidth>
                    <RadioGroup row>
                      <FormControlLabel
                        value="p"
                        control={
                          <Radio
                            checked={formik.values.radioCheck}
                            onClick={() => {
                              formik.setFieldValue(`radioCheck`, true);
                            }}
                          />
                        }
                        label="ผ่าน"
                      />
                      <FormControlLabel
                        value="n"
                        control={
                          <Radio
                            checked={!formik.values.radioCheck}
                            onClick={() => {
                              formik.setFieldValue(`radioCheck`, false);
                            }}
                          />
                        }
                        label="ไม่ผ่าน"
                      />
                    </RadioGroup>
                  </FormControl>

                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ marginTop: 10 }}
                    className={classes.warpFormControl}
                  >
                    <InputLabel>ร่างข้อความแจ้งผลกับผู้ยื่น</InputLabel>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      className={classes.formControl}
                      style={{ marginTop: 10 }}
                    >
                      <TextField
                        variant="outlined"
                        name="commentToPersonal"
                        value={formik.values.commentToPersonal}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("commentToPersonal", formik)}
                        helperText={getErrorMessage(
                          "commentToPersonal",
                          formik
                        )}
                        multiline
                        rows={5}
                      />
                    </FormControl>
                    <div
                      style={{
                        marginTop: 22,
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <ColorButton
                        style={{ height: 40, width: 125 }}
                        variant="outlined"
                        color="primary"
                        onClick={() => {}}
                      >
                        Back
                      </ColorButton>
                      <ColorButton
                        style={{ height: 40, width: 125, marginLeft: 20 }}
                        variant="contained"
                        color="primary"
                        disabled={!formik.isValid}
                        type="submit"
                      >
                        Submit
                      </ColorButton>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </>
          </Paper>
        </>
      )}
      {/* End For Boi Staff */}
      {/* Dialog History */}
      <Dialog
        onClose={() => setDialogHistory(false)}
        aria-labelledby="simple-dialog-title"
        open={DialogHistory}
        fullWidth={true}
        className={classes.warpDialog}
        maxWidth="md"
      >
        <DialogTitle id="simple-dialog-title" className={classes.dtitle}>
          <ContentTitle title="History" />
        </DialogTitle>
        <DialogContent>
          <div className={classes.warpRowDialog}>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <FormControl
                  variant="outlined"
                  style={{ width: "100%" }}
                  className={classes.formControl}
                >
                  <DialogContent>
                    <DialogContentText
                      id="scroll-dialog-description"
                      tabIndex={-1}
                    >
                      {reasonListDirector_data.map((x) => (
                        <>
                          <Box
                            sx={{
                              width: "100%",
                              height: "100%",
                              backgroundColor: "#F8F8F8",
                              "&:hover": {
                                backgroundColor: "#F8F8F8",
                                opacity: [0.9, 0.8, 0.7],
                              },
                              padding: 10,
                              borderRadius: 10,
                              marginTop: 5,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "wrap",
                                marginBottom: 5,
                              }}
                            >
                              <Typography
                                variant="h6"
                                style={{ color: "#101A5F" }}
                              >
                                {" "}
                                {x?.smartserviceName} |
                              </Typography>

                              {x?.isPass ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    marginLeft: 5,
                                  }}
                                >
                                  <CheckCircle
                                    style={{
                                      color: "#2DCE98",
                                      marginRight: 10,
                                    }}
                                  />
                                  ผ่าน
                                </div>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    marginLeft: 5,
                                  }}
                                >
                                  <CancelIcon
                                    style={{
                                      color: "#FEB969",
                                      marginRight: 10,
                                    }}
                                  />
                                  ไม่ผ่าน
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexWrap: "wrap",
                                marginBottom: 5,
                              }}
                            >
                              <DateRangeIcon
                                style={{ color: "#1094D8", marginRight: 10 }}
                              />
                              {moment(x?.reasonDate).format(
                                "DD/MM/YYYY hh:mm:ss"
                              )}
                            </div>
                            <Typography
                              variant="h6"
                              style={{ color: "#101A5F", marginBottom: 5 }}
                            >
                              {" "}
                              ความเห็นเสนอผู้อำนวยการ
                            </Typography>
                            <Typography>{x?.commentToDirector}</Typography>
                            <Typography
                              variant="h6"
                              style={{ color: "#00D0FF", marginBottom: 5 }}
                            >
                              {" "}
                              ร่างข้อความแจ้งผลกับผู้ยื่น
                            </Typography>
                            <Typography> {x?.commentToPersonal}</Typography>
                          </Box>
                        </>
                      ))}
                    </DialogContentText>
                  </DialogContent>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <center>
          <ColorButton
            style={{ margin: 5, height: 40, width: 125 }}
            variant="outlined"
            color="primary"
            onClick={() => {
              setDialogHistory(false);
            }}
          >
            Back
          </ColorButton>
        </center>
      </Dialog>
      {/* End Dialog */}
    </>
  );
}

export default ViewReasonDetail;
